import { memo } from 'react'

const AddToCampaignIcon = memo(({ size = 32, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <mask id="path-1-inside-1_4609_57100" fill="white">
                <rect x="5.33203" y="5.33398" width="9.48148" height="9.48148" rx="0.888889" />
            </mask>
            <rect
                x="5.33203"
                y="5.33398"
                width="9.48148"
                height="9.48148"
                rx="0.888889"
                stroke="#899CBD"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#path-1-inside-1_4609_57100)"
            />
            <mask id="path-2-inside-2_4609_57100" fill="white">
                <rect x="17.1836" y="5.33398" width="9.48148" height="9.48148" rx="0.888889" />
            </mask>
            <rect
                x="17.1836"
                y="5.33398"
                width="9.48148"
                height="9.48148"
                rx="0.888889"
                stroke="#899CBD"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#path-2-inside-2_4609_57100)"
            />
            <mask id="path-3-inside-3_4609_57100" fill="white">
                <rect x="5.33203" y="17.1855" width="9.48148" height="9.48148" rx="0.888889" />
            </mask>
            <rect
                x="5.33203"
                y="17.1855"
                width="9.48148"
                height="9.48148"
                rx="0.888889"
                stroke="#899CBD"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#path-3-inside-3_4609_57100)"
            />
            <path d="M18 22L26 22" stroke="#899CBD" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M22 18L22 26" stroke="#899CBD" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
})

AddToCampaignIcon.displayName = 'AddToCampaignIcon'

export { AddToCampaignIcon }
